import moment from "moment"
import { Address, DateInt, DirectorDto } from "./DirectorSectionTypes"

export function extractDateFromDateInt(date: DateInt): string {
	const hasYear = date.year > 0
	const hasMonth = date.month > 0
	const hasDay = date.day > 0
	if (hasDay && hasMonth && hasYear) {
		return moment(new Date(date.year, date.month, date.day)).format('Do MMMM YYYY')
	}

	if (!hasDay && hasMonth && hasYear) {
		return moment(new Date(date.year, date.month)).format('Do MMMM');
	}

	if (hasYear) {
		return `${date.year}`;
	}

	return "-"
}

function getAddressString(address: Address) {
	return Object.values(address).filter(Boolean).join(", ");
}

function getPlaceOfBirth(data: string[]) {
	return data.filter(Boolean).join(" ");
}

export const DirectorInformationSection = ({ director }: { director: DirectorDto }) => {
	const hasDateOfBirth = director.dateOfBirth.year > 0;
	const hasPlaceOfBirth = director.birthLocation || director.birthState;
	const hasAddress = Object.values(director.address).some(Boolean);
	const hasAppointedInfo = director.appointedDate.year > 0;
	const hasCompanyInfo = director.companyName;
	const hasCompanyAcn = director.companyAcn;

	return (
		<div className="info-section">
			{(hasDateOfBirth || hasPlaceOfBirth || hasCompanyInfo || hasCompanyAcn) && (
				<div className="info-section-item">
					{hasDateOfBirth && (
						<p className="content">
							<span>Date of birth:</span>
							<span>{extractDateFromDateInt(director.dateOfBirth)}</span>
						</p>
					)}
					{hasPlaceOfBirth && (
						<p className="content">
							<span>Place of birth:</span>
							<span>{getPlaceOfBirth([director.birthLocation, director.birthState])}</span>
						</p>
					)}
					{hasCompanyInfo && (
						<p className="content">
							<span>Company:</span>
							<span>{director.companyName}</span>
						</p>
					)}
					{hasCompanyAcn && (
						<p className="content">
							<span>ACN:</span>
							<span>{director.companyAcn}</span>
						</p>
					)}
				</div>
			)}
			{(hasAppointedInfo || hasAddress) && (
				<div className="info-section-item">
					{hasAppointedInfo && (
						<p className="content">
							<span>Appointed:</span>
							<span>{extractDateFromDateInt(director.appointedDate)}</span>
						</p>
					)}
					{hasAddress && (
						<p className="content">
							<span>Address:</span>
							<span>{getAddressString(director.address)}</span>
						</p>
					)}
				</div>
			)}
		</div>
	)
}